export default __webpack_public_path__ + "media/gallery/vedett-eff53ffa.jpg";